import axios from "axios";

import { API_URL, JWT_TOKEN } from "../constant";
import { clearLocalStorage, getLocalStorage } from "./storageUtil";
import history from "./history";
import { message } from "antd";
export const httpBaseUtils = () => {
  const instance = axios.create({
    baseURL: API_URL,
    headers: {
      Accept: "*/*",
      Authorization: `${getLocalStorage(JWT_TOKEN)}`,
    },
  });
  // Add a response interceptor
  instance.interceptors.response.use(
    (response) => {
      // console.log("🚀 ~ httpBaseUtils ~ response:", JSON.stringify(response))
      const xsrfToken = response.headers["X-XSRF-TOKEN"];
      return response;
    }, // Return response normally if successful
    (error) => {
      console.log("🚀 ~ httpBaseUtils ~ error:", error);
      if (error.response && error.response.status === 401) {
        // Token expired or unauthorized, log the user out
        clearLocalStorage(JWT_TOKEN); // Clear stored token
        message.error(
          error.response.data.message ||
            "Your session has expired. Please log in again."
        );
        history.push("/"); // Redirect user to login page
      }
      return Promise.reject(error); // Return the error for further handling
    }
  );

  return instance;
};

export const httpBaseUploadUtils = () => {
  return axios.create({
    baseURL: API_URL,
    headers: {
      Accept: "*/*",
      "Content-Type": "multipart/form-data",
      Connection: "keep-alive",
      Authorization: `Bearer ${getLocalStorage(JWT_TOKEN)}`,
    },
  });
};
